import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar,Table} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function B2b() {

    const {accountingData,setAccountingData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {exhibition,setExhibition}=useContext(UserContext)
    const {catalogueData,setCatalogueData}=useContext(UserContext)
    const [show,setShow]=useState(false)
    const {items,setItems}=useContext(UserContext)
    const [itemsLocal,setItemsLocal]=useState([])
    const [grandTotal,setGrandTotal]=useState(0)
    const {sendForm}=useContext(UserContext)


    useEffect(()=>{
       // console.log(accountingData)

    },[activeTab,exhibition])

    const changeTab=(e)=>{
        e.preventDefault()
        window.scroll(0,0)
        setActiveTab('firms')
    }

  return (
    <Container fluid>

    <Alert variant='success'>
      <h4>ΣΤΟΙΧΕΙΑ ΥΠΕΥΘΥΝΟΥ B2B // B2B CONTACT DETAILS</h4>
    </Alert>
   
    <Form onSubmit={changeTab}>
        <Form.Group className="mb-3">
            <Form.Label><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ B2B// B2B CONTACT PERSON</b></Form.Label>
            <Form.Control type="text" value={catalogueData.xpname}  onChange={(e)=>{setCatalogueData({...catalogueData, xpname:e.target.value})}}   />
          </Form.Group> 

          <Form.Group className="mb-3">
              <Form.Label><b>ΤΗΛΕΦΩΝΟ ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON TELEPHONE</b></Form.Label>
              <Form.Control type="text"  value={catalogueData.xpphone} onChange={(e)=>{setCatalogueData({...catalogueData, xpphone:e.target.value})}}/>
              </Form.Group>              
   
              <Form.Group className="mb-3">
              <Form.Label><b>ΕΜΑΙL ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON ΕΜΑΙL</b></Form.Label>
              <Form.Control type="email" value={catalogueData.xpemail} onChange={(e)=>{setCatalogueData({...catalogueData, xpemail:e.target.value})}}/>
              </Form.Group>

 
    <br/><br/><br/><br/>
    <Navbar bg="light" fixed="bottom" >
        <table width="100%"><tbody><tr>
          
              <td align="left">
                  {accountingData.CMTIN && 
                    <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                  }
              

            </td>             
          
          <td align="right">
        <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('catalogue')}}>ΠΙΣΩ // BACK</Button>
        &nbsp;
        <Button type="submit" variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>

        </td></tr></tbody></table>
    </Navbar> 

    </Form>
    </Container>
    )

}